import {
  GridComponent,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Inject,
  Resize,
  Edit,
  CommandColumn,
  ForeignKey,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  RowDD,
} from "@syncfusion/ej2-react-grids";
import { auth, cicassService } from "../../../../_services";
import React from "react";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { withTranslation } from "react-i18next";
import { SwitchComponent } from "@syncfusion/ej2-react-buttons";
import { getValue } from "@syncfusion/ej2-base";
import { rippleMouseHandler } from "@syncfusion/ej2-buttons";
import { Typography, Box} from "@mui/material";

const editSettings = {
  allowEditing: true,
  allowAdding: true,
  allowDeleting: true,
  mode: "Dialog",
  dialog: { enableResize: true },
  showDeleteConfirmDialog: true,
};
const filterSettings = { type: "CheckBox" }; // Menu, Excel
const commands = [
  {
    type: "Edit",
    buttonOption: { iconCss: " e-icons e-edit", cssClass: "e-flat" },
  },
  {
    type: "Delete",
    buttonOption: { iconCss: "e-icons e-delete", cssClass: "e-flat" },
  },
  {
    type: "Save",
    buttonOption: { iconCss: "e-icons e-update", cssClass: "e-flat" },
  },
  {
    type: "Cancel",
    buttonOption: { iconCss: "e-icons e-cancel-icon", cssClass: "e-flat" },
  },
];
const toolbarOptions = [
  "Search",
  "Add",
  "ExcelExport",
  "Print",
  {
    text: "Refresh",
    tooltipText: "Refresh",
    prefixIcon: "e-MT_reload",
    id: "forceRefresh",
  },
  {
    text: "Back",
    tooltipText: "Back",
    prefixIcon: "e-MT_Backward",
    id: "backToList",
  },
];
const apiUrl = "ana_field";
const apiUrlFieldType = "ana_field_type";
const apiUrlAnaUserRole = "ana_user_role/combo/";

class Shift extends React.Component {
  _isMounted = false;
  grid = null;
  constructor(props) {
    super(props);
    this.position = { X: "Right", Y: "Bottom" };
    this.state = {
      myData: {},
      fieldTypeData: [],
      userRoleData: [],
      visibleOnGrid: false,
      didMountCompleted: false,
      isCicass: false,
      anaCalendarTemplateIdSelected: 0,
      toastInfo: {
        title: "",
        content: "Succesfully",
        cssClass: "e-toast-success",
        icon: "e-success toast-icons",
      },
    };
    this.validationRules = { required: true };
    this.actionComplete = this.actionComplete.bind(this);
    this.actionBegin = this.actionBegin.bind(this);
    this.refreshGrid = this.refreshGrid.bind(this);
    this.editTemplateSwitch = this.editTemplateSwitch.bind(this);
    this.templateSwitch = this.templateSwitch.bind(this);
    this.changeFnSwitch = this.changeFnSwitch.bind(this);
  }

  async componentDidMount() {
    this._isMounted = true;
    const weblang = localStorage.getItem("weblang");
    const myRole = auth.getUserRole();
    const anaCalendarTemplateIdSelected = this.props.match.params.id;
    let { data: myData } = await cicassService.getAll(
      apiUrl + "/template/" + anaCalendarTemplateIdSelected
    );
    let { data: fieldTypeData } = await cicassService.getAll(apiUrlFieldType);
    let { data: userRoleData } = await cicassService.getAll(
      apiUrlAnaUserRole + anaCalendarTemplateIdSelected
    );
    if (this._isMounted) {
      this.setState({
        didMountCompleted: true,
        myData,
        anaCalendarTemplateIdSelected,
        userRoleData,
        fieldTypeData,
        isCicass: myRole == "SuperUser" ? true : false,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toolbarClick(args) {
    switch (args.item.properties.id) {
      case "gridcomp_excelexport":
        this.gridInstance.excelExport();
        break;
    }
    if (args.item.id === "forceRefresh") {
      this.refreshGrid();
    }
    if (args.item.id === "backToList") {
      this.props.history.push(`/app/template/`);
    }
  }

  actionBegin(state) {
    if (state.requestType == "beginEdit" || state.requestType == "add") {
      if (state.requestType == "add") {
        state.id = -1;
      }
      this.setState({ visibleOnGrid: true });
    }
  }

  refreshGrid() {
    const { anaCalendarTemplateIdSelected } = this.state;
    cicassService
      .getAll(apiUrl + "/template/" + anaCalendarTemplateIdSelected)
      .then((response) => {
        this.setState({ myData: response.data });
      });
  }

  setToastInfo(title, errorMsg) {
    let { toastInfo } = this.state;
    switch (title) {
      case "Warning":
        toastInfo.title = "Warning";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-warning";
        toastInfo.icon = "e-warning toast-icons";
        break;
      case "Success":
        toastInfo.title = "Success";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-success";
        toastInfo.icon = "e-success toast-icons";
        break;
      case "Error":
        toastInfo.title = "Error";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-danger";
        toastInfo.icon = "e-error toast-icons";
        break;
      case "Information":
        toastInfo.title = "Information";
        toastInfo.content = errorMsg;
        toastInfo.cssClass = "e-toast-info";
        toastInfo.icon = "e-info toast-icons";
        break;
    }
    this.setState({ toastInfo });
    this.toastObj.show();
    return;
  }

  actionComplete(state) {
    if (state.requestType === "add" || state.requestType === "beginEdit") {
      state.dialog.enableResize = true;
      //state.dialog.element.style.maxHeight = 900;
      state.dialog.width = 600;
      state.dialog.height = 600;
      this.rowData = Object.assign({}, state.rowData);
    }
    if (state.action === "add") {
      state.data.id = -1;
      state.data.anaCalendarTemplateId = parseInt(this.rowData.anaCalendarTemplateId);
      state.data.createdAt = new Date();
      cicassService
        .saveOp(apiUrl, state.data)
        .then(() => {
          this.refreshGrid();
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          this.setToastInfo("Error", "I: " + err.message);
          this.refreshGrid();
        });
    }
    if (state.action === "edit") {
      let dataToSave = state.data;
      dataToSave.isHidden = this.rowData.isHidden;
      dataToSave.isMandatory = this.rowData.isMandatory;
      //dataToSave.isAnaUserIdCombo = this.rowData.isAnaUserIdCombo;
      //console.log("Row",this.rowData);
      //console.log("State",state.data);
      cicassService
        .saveOp(apiUrl, dataToSave)

        .then(() => {
          this.refreshGrid();
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          this.setToastInfo("Error", "U: " + err.message);
          this.refreshGrid();
        });
    }
    if (state.requestType === "delete") {
      cicassService
        .deleteOp(apiUrl, state.data[0].id)
        .then(() => {
          this.refreshGrid();
          this.setToastInfo("Success", this.props.t("toastSuccess"));
        })
        .catch((err) => {
          this.setToastInfo("Error", "D: " + err.message);
          this.refreshGrid();
        });
    }
    this.setState({ visibleOnGrid: false });
  }

  editTemplateSwitch(args, colName) {
    let isChecked = getValue(colName, args);
    let id = "id_" + colName;
    return (
      <div>
        <label htmlFor={id} style={{ padding: "10px 72px 10px 0" }}>
          {this.props.t(colName)}
        </label>
        <SwitchComponent
          id={id}
          checked={isChecked}
          change={(e) => this.changeFnSwitch(e, colName)}
        />
      </div>
    );
  }

  templateSwitch(args, colName) {
    let isChecked = getValue(colName, args) == 1 ? true : false;
    if (isChecked) return <i className="far fa-check-square"></i>;
    return <i className="far fa-square"></i>;
  }

  changeFnSwitch(args, colName) {
    if (this.rowData) {
      this.rowData[colName] = args.checked ? 1 : 0;
    }
  }

  dropAction(args) {
    if (args.dropIndex != args.fromIndex) {
      let dataToSave = args.data[0];
      dataToSave.viewOrder = args.dropIndex + 1;
      cicassService
        .saveOp(apiUrl + "/reorder", dataToSave)
        .then((e) => this.refreshGrid());
    }
  }

  renderComplete() {
    let elemArray = document.querySelectorAll(".switch-control label");
    for (let i = 0, len = elemArray.length; i < len; i++) {
      elemArray[i].addEventListener("mouseup", rippleHandler);
      elemArray[i].addEventListener("mousedown", rippleHandler);
    }
    function rippleHandler(e) {
      let rippleSpan = this.nextElementSibling.querySelector(
        ".e-ripple-container"
      );
      if (rippleSpan) {
        rippleMouseHandler(e, rippleSpan);
      }
    }
  }

  render() {
    const {
      myData,
      didMountCompleted,
      isCicass,
      toastInfo,
      fieldTypeData,
      anaCalendarTemplateIdSelected,
      userRoleData,
    } = this.state;
    const { t } = this.props;
    const comboTypeDataSource = [
      { id: 0, name: t("Nessuna Combo / Combo Pre Impostata") },
      { id: 1, name: t("Anagrafica Utenti") },
      { id: 2, name: t("Anagrafica Mezzi") }
    ];

    return (
      <>
        <div style={{ margin: "1%", marginTop: "1%" }}>
          <Typography variant="h6" component="h2">
            {t("titleAnaFieldJs")}: {this.props.location.state}
          </Typography>
        </div>
        <Box sx={{ p: 2, flex: '1 1 auto' }}>
          {didMountCompleted && (
            <GridComponent
              id="gridcomp"
              ref={(grid) => (this.gridInstance = grid)}
              dataSource={myData}
              toolbar={toolbarOptions}
              editSettings={editSettings}
              allowResizing={true}
              allowFiltering={true}
              filterSettings={filterSettings}
              allowPaging={false}
              pageSettings={{ pageSize: 10, pageCount: 5 }}
              allowExcelExport={true}
              actionComplete={this.actionComplete}
              actionBegin={this.actionBegin}
              toolbarClick={this.toolbarClick.bind(this)}
              locale="it"
              allowSorting={true}
              allowRowDragAndDrop={true}
              rowDrop={this.dropAction.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="name"
                  headerText={t("name")}
                  width="150"
                  validationRules={this.validationRules}
                />
                <ColumnDirective
                  field="description"
                  headerText={t("description")}
                />
                <ColumnDirective
                  field="anaFieldTypeId"
                  headerText={t("anaFieldTypeId")}
                  foreignKeyValue="name"
                  foreignKeyField="id"
                  dataSource={fieldTypeData}
                  width="150"
                  validationRules={this.validationRules}
                />
                <ColumnDirective
                  field="eligibleValues"
                  headerText={t("eligibleValues")}
                  width="150"
                />
                <ColumnDirective
                  field="isAnaUserIdCombo"
                  headerText={t("Tipo Comportamento Campo")}
                  width="150"
                  foreignKeyValue="name"
                  foreignKeyField="id"
                  dataSource={comboTypeDataSource}
                />
                <ColumnDirective
                  field="filterAnaUserRoleId"
                  headerText={t("filterAnaUserRoleId")}
                  foreignKeyValue="name"
                  foreignKeyField="id"
                  dataSource={userRoleData}
                  width="150"
                />
                <ColumnDirective
                  field="isHidden"
                  headerText={t("isHidden")}
                  editType="numericedit"
                  defaultValue={0}
                  editTemplate={(e) => this.editTemplateSwitch(e, "isHidden")}
                  template={(e) => this.templateSwitch(e, "isHidden")}
                />
                <ColumnDirective
                  field="isMandatory"
                  headerText={t("isMandatory")}
                  editType="numericedit"
                  defaultValue={1}
                  editTemplate={(e) =>
                    this.editTemplateSwitch(e, "isMandatory")
                  }
                  template={(e) => this.templateSwitch(e, "isMandatory")}
                />
                <ColumnDirective
                  field="viewOrder"
                  headerText={t("viewOrder")}
                  defaultValue={99}
                />
                <ColumnDirective
                  field="createdAt"
                  headerText={t("createdAt")}
                  type="date"
                  format={"dd/MM/yyyy HH:mm:ss"}
                  visible={isCicass}
                  allowEditing={false}
                />
                <ColumnDirective
                  field="deletedAt"
                  headerText={t("deletedAt")}
                  type="date"
                  format={"dd/MM/yyyy HH:mm:ss"}
                  visible={false}
                  allowEditing={false}
                />
                <ColumnDirective
                  field="updatedAt"
                  headerText={t("updatedAt")}
                  type="date"
                  format={"dd/MM/yyyy HH:mm:ss"}
                  visible={isCicass}
                  allowEditing={false}
                />
                <ColumnDirective
                  field="id"
                  headerText={t("id")}
                  textAlign="Right"
                  isPrimaryKey={true}
                  defaultValue="-1"
                  allowEditing={false}
                  visible={false}
                />
                <ColumnDirective
                  field="anaCalendarTemplateId"
                  headerText={t("anaCalendarTemplateId")}
                  visible={false}
                  defaultValue={anaCalendarTemplateIdSelected}
                />
                <ColumnDirective
                  headerText={t("operationOnGrid")}
                  width="160"
                  commands={commands}
                ></ColumnDirective>
              </ColumnsDirective>
              <Inject
                services={[
                  RowDD,
                  Resize,
                  Filter,
                  Toolbar,
                  Edit,
                  ForeignKey,
                  CommandColumn,
                  ExcelExport,
                  Sort,
                ]}
              />
            </GridComponent>
          )}
          <ToastComponent
            ref={(toast) => {
              this.toastObj = toast;
            }}
            id="toast_default"
            position={this.position}
            title={toastInfo.title}
            content={toastInfo.content}
            cssClass={toastInfo.cssClass}
            icon={toastInfo.icon}
          ></ToastComponent>
        </Box>
      </>
    );
  }
}
export default withTranslation()(Shift);
